/**
 * Runtime audit for the floating NFHS reader iframes.
 *
 * Run `nfhsReaderAudit()` in the console. Confirm src matches the expected
 * path (/book/{id}). NFHS may navigate the frame to /pdf or /interactive after load.
 */
export function installNfhsReaderAudit () {
  if (typeof window === 'undefined') return
  window.nfhsReaderAudit = () => {
    const frames = Array.from(document.querySelectorAll('iframe')).filter((frame) => {
      const src = frame.getAttribute('src') || ''
      return src.includes('nfhsdigital.org')
    })
    const framesRows = frames.map((frame) => {
      const rect = frame.getBoundingClientRect()
      const style = window.getComputedStyle(frame)
      const src = frame.getAttribute('src') || ''
      const pathMatch = src.match(/\/book\/[^/]+(?:\/(pdf|interactive|detail))?/i)
      return {
        liveSrc: src,
        readerKind: pathMatch?.[1] || 'html',
        sandbox: frame.getAttribute('sandbox'),
        cssSize: `${style.width} x ${style.height}`,
        boxSize: `${Math.round(rect.width)} x ${Math.round(rect.height)}`,
        visible: rect.width > 0 && rect.height > 0 && style.visibility !== 'hidden',
      }
    })

    let storeReaders = []
    try {
      // Pinia main store shape: nfhsDigital.readers
      const pinia = window.__PINIA__ || null
      const main = pinia?._s?.get('main') || null
      const readers = main?.nfhsDigital?.readers || []
      storeReaders = readers.map((reader) => ({
        id: reader.id,
        mode: reader.mode,
        type: reader.publication?.type || null,
        isInteractive: reader.publication?.isInteractive ?? null,
        smart: reader.publication?.features?.smart ?? null,
        viewerType: reader.publication?.features?.viewerType || null,
        readerPath: reader.publication?.readerPath || null,
        readerUrl: reader.publication?.readerUrl || null,
        title: reader.publication?.title || null,
      }))
    } catch (_) {
      storeReaders = []
    }

    const report = {
      parentOrigin: window.location.origin,
      frameCount: frames.length,
      frames: framesRows,
      storeReaders,
      outerHTML: frames.map((frame) => frame.outerHTML),
    }
    console.group('NFHS reader audit')
    console.log('parent origin:', report.parentOrigin)
    console.table(framesRows)
    if (storeReaders.length) console.table(storeReaders)
    report.outerHTML.forEach((html, index) => console.log(`outerHTML[${index}]:`, html))
    console.groupEnd()
    return report
  }
}
